import { useContext } from 'react'
import store from 'storeContext'
import styled from 'styled-components'
import BodyV2 from './BodyV2'
import Footer from './Footer'
import Header from './Header'

const TemplateOrderPackerWaitingDriver = () => {
  const { state: statePrintArea } = useContext(store.PrintAreaContext) as unknown as {
    state: {
      dataResiOrderPackerWaitingDriver: {
        packageList: { paketNumber: string; packageId: string }[]
        order_type: string
        order_packages: { packageId: string }[]
        order_id: string
        order_customer_address: {
          customer_name: string
          customer_address_label: string
          customer_address_place: string
          customer_address_detail: string
          customer_address_description: string
          customer_address_instruction: string
        }
        order_invoice: string
        is_twenty_one_plus: boolean
        order_note: string
        delivery_handling: {
          has_big_item: boolean
          is_eggs: boolean
          is_fragile: boolean
          is_melting: boolean
          is_refill: boolean
          is_rotten: boolean
        }
      }
    }
    dispatch: StoreDispatchType
  }
  if (!statePrintArea.dataResiOrderPackerWaitingDriver) return null

  const {
    dataResiOrderPackerWaitingDriver: {
      packageList,
      delivery_handling,
      order_customer_address: { customer_address_instruction },
      order_note,
    },
  } = statePrintArea

  const renderTemplate = () =>
    packageList?.map(({ paketNumber, packageId }) => (
      <Wrapper key={paketNumber}>
        <Header orderType={statePrintArea.dataResiOrderPackerWaitingDriver.order_type} />
        <BodyV2
          data={statePrintArea.dataResiOrderPackerWaitingDriver}
          packageOrderNumber={paketNumber}
          packageId={packageId}
          orderPackage={statePrintArea.dataResiOrderPackerWaitingDriver.order_packages.find(
            (el) => el.packageId === packageId,
          )}
        />
        <Footer
          orderNote={order_note}
          deliveryInstruction={customer_address_instruction}
          deliveryHandling={delivery_handling}
        />
      </Wrapper>
    ))

  return packageList?.length ? <WrapperContainer>{renderTemplate()}</WrapperContainer> : null
}

export default TemplateOrderPackerWaitingDriver

const WrapperContainer = styled.div`
  display: contents; /* Tidak menambah lapisan visual tapi tetap jadi root element */
`

const Wrapper = styled.div`
  box-sizing: border-box;
  display: grid;
  grid-template-rows: 8mm minmax(0, 1fr) 23mm;
  gap: 2mm;
  padding: 3mm;
  width: 102mm;
  height: 102mm;
  overflow: hidden;

  & *,
  & *::before,
  & *::after {
    box-sizing: border-box;
  }

  & * {
    min-width: 0;
    overflow-wrap: anywhere;
  }

  @media print {
    break-inside: avoid;
    break-after: page;

    &:last-child {
      break-after: auto;
    }

    @page {
      size: 102mm 102mm;
      margin: 0;
    }
  }
`
